var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inline-svg',{class:_vm.isSelected ?
    'MenuRowIcon MenuRowIcon--selected' :
    'MenuRowIcon MenuRowIcon--deselected',attrs:{"src":require('@/assets/menu/' + _vm.icon)}})}
var staticRenderFns = []

export { render, staticRenderFns }